import { Box, Stack, Typography } from "@mui/material";
import EditIcon from "../../../../../../Assets/Icons/edit-icon.svg";
import DeleteIcon from "../../../../../../Assets/Icons/trash-purple.svg";
import useGuestListStore from "../../../../../../stores/useGuestListStore";
import MailIcon from "../../../../../../Assets/Icons/mail.svg";
import PhoneIcon from "../../../../../../Assets/Icons/phone.svg";

const GuestItem = (guestInfo) => {
  const { primary, additional } = guestInfo;

  const { setIsAddingGuest, setSelectedGuest, setIsDeletingGuest } =
    useGuestListStore();

  const additionalCount =
    additional?.filter((guest) => !guest.isPrimary).length || 0;

  return (
    <Box
      backgroundColor="#fff1f2"
      padding="10px"
      borderRadius="10px"
      mb="12px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Typography fontWeight={500} display="flex" alignItems="center" gap={1}>
          {primary.firstName} {primary.lastName}&nbsp;
          {additionalCount > 0 && (
            <Box
              component="span"
              fontWeight={600}
              fontSize={10}
              width={22}
              height={22}
              borderRadius="50%"
              backgroundColor="#D1D1D6"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {additionalCount}+
            </Box>
          )}
        </Typography>

        <Stack display="flex" direction="row" alignItems="center" gap={1}>
          <img src={MailIcon} alt="mail" />
          <Typography
            fontSize={14}
            color="#757575"
            display="flex"
            alignItems="center"
            gap={1}
          >
            {primary.email}
          </Typography>
        </Stack>

        {primary.phone && (
          <Stack display="flex" direction="row" alignItems="center" gap={1}>
            <img src={PhoneIcon} alt="phone" />
            <Typography
              fontSize={14}
              color="#757575"
              display="flex"
              alignItems="center"
              gap={1}
            >
              {primary.phone}
            </Typography>
          </Stack>
        )}
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <img
          src={EditIcon}
          alt="edit"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          onClick={() => {
            setIsAddingGuest(true);
            setSelectedGuest(guestInfo);
          }}
        />
        <img
          src={DeleteIcon}
          alt="delete"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          onClick={() => {
            setIsDeletingGuest(true);
            setSelectedGuest(guestInfo);
          }}
        />
      </Box>
    </Box>
  );
};

export default GuestItem;
